import { useState, useEffect } from 'react';
import { PeriodButton, PeriodButtonContainer, PeriodEditorContainer, QuarterOption, QuarterSelector, YearArrow, YearDisplay, YearSelector } from './PeriodTagCategory.styles';

const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];

export const PeriodEditor = ({ tag, showButtons, onChange, onSave, onCancel }) => {
    const [selectedYear, setSelectedYear] = useState('2025');
    const [selectedPeriod, setSelectedPeriod] = useState(null);

    useEffect(() => {
        if (tag) {
            const splitTag = tag.split('-');
            if (splitTag.length === 2) {
                setSelectedYear(parseInt(splitTag[1]));
                setSelectedPeriod(splitTag[0]);
            } else {
                setSelectedYear(parseInt(splitTag[0]));
                setSelectedPeriod(null);
            }
        } else {
            setSelectedYear(2025);
            setSelectedPeriod(null);
        }
    }, [tag]);

    const handlePeriodSave = () => {
        const period = selectedPeriod ? `${selectedPeriod}-${selectedYear}` : `${selectedYear}`;
        onSave(period);
    };

    const handlePeriodCancel = () => onCancel();

    const handleYearChange = (year) => {
        setSelectedYear(year);
        onChangePeriod(selectedPeriod, year);
    };

    const handleChangeQuarter = (quarter) => {
        setSelectedPeriod(quarter);
        onChangePeriod(quarter, selectedYear);
    }

    const onChangePeriod = (quarter, year) => {  
        if (!onChange) return;

        const period = quarter ? `${quarter}-${year}` : `${year}`;
        onChange(period);
    }  

    return (
        <PeriodEditorContainer>
            <YearSelector>
                <YearArrow isLeft onClick={() => handleYearChange(selectedYear - 1)}>‹</YearArrow>
                <YearDisplay>{selectedYear}</YearDisplay>
                <YearArrow isRight onClick={() => handleYearChange(selectedYear + 1)}>›</YearArrow>
            </YearSelector>
            <QuarterSelector>
                <QuarterOption
                    isSelected={!selectedPeriod}
                    onClick={() => handleChangeQuarter(null)}
                >
                    All
                </QuarterOption>
                {QUARTERS.map(quarter => (
                    <QuarterOption
                        key={quarter}
                        isSelected={selectedPeriod === quarter}
                        onClick={() => handleChangeQuarter(quarter)}
                    >
                        {quarter}
                    </QuarterOption>
                ))}
            </QuarterSelector>
            {
                showButtons && (
                    <PeriodButtonContainer>
                        <PeriodButton variant="secondary" onClick={handlePeriodCancel}>
                            Cancel
                        </PeriodButton>
                        <PeriodButton variant="primary" onClick={handlePeriodSave}>
                            Save
                        </PeriodButton>
                    </PeriodButtonContainer>
                )
            }
        </PeriodEditorContainer>
    );
};